// extracted by mini-css-extract-plugin
export var completionBody = "_l6-2";
export var completionCard = "_l6-0";
export var completionFooter = "_l6-3";
export var completionTitle = "_l6-1";